import { RegionToolbarStore } from 'shared/stores/annotations/RegionToolbarStore';
import { AnnotationsLockdownService } from './AnnotationsLockdownService';
import { DrawingStore } from './DrawingStore';
import { AnnotationsStore } from './AnnotationsStore';

export * from './consts';

export const stores = [
  DrawingStore,
  AnnotationsStore,
  AnnotationsLockdownService,
  RegionToolbarStore
];



// WEBPACK FOOTER //
// ./src/shared/stores/annotations/index.js